var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceSecuring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "service_securing",
    transform: "translate(0 -1041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5883",
    "data-name": "Rectangle 5883",
    width: 64,
    height: 64,
    rx: 12,
    transform: "translate(0 1041)",
    fill: "#2e8b57",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "_003-protected",
    "data-name": "003-protected",
    transform: "translate(16 1055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M3.716,27.13a7.515,7.515,0,0,0,4.446,5.495L14,35.481c.026.013.052.024.078.035a6.207,6.207,0,0,0,4.8,0l.078-.035L24.8,32.624a7.53,7.53,0,0,0,4.453-5.53L32.427,7.9a2.971,2.971,0,0,0-.565-2.362,3.059,3.059,0,0,0-2.14-1.177L25.428,3.93a7.757,7.757,0,0,1-3.019-.9L17.958.376A3.1,3.1,0,0,0,14.95.4L10.6,3a5.837,5.837,0,0,1-2.588.931l-4.758.425A3.07,3.07,0,0,0,1.1,5.534,2.976,2.976,0,0,0,.527,7.876ZM8.287,6.917a8.911,8.911,0,0,0,3.842-1.324L16.48,3l4.4,2.622a10.839,10.839,0,0,0,4.256,1.295l4.287.462-3.177,19.2a4.51,4.51,0,0,1-2.693,3.308l-.078.035-5.833,2.854a3.1,3.1,0,0,1-2.33,0L9.481,29.919c-.026-.013-.052-.024-.078-.035a4.494,4.494,0,0,1-2.686-3.272L3.534,7.378c0-.012,0-.023-.006-.035Zm0,0",
    transform: "translate(-0.479 0)",
    fill: "#2e8b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    "data-name": "Path 4040",
    d: "M101.513,154.045a1.54,1.54,0,0,0,2.155,0l7.619-7.5a1.483,1.483,0,0,0,0-2.121,1.541,1.541,0,0,0-2.155,0l-6.542,6.439L99.1,147.423a1.541,1.541,0,0,0-2.155,0,1.484,1.484,0,0,0,0,2.121Zm0,0",
    transform: "translate(-87.351 -130.483)",
    fill: "#2e8b57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSecuring);
export default __webpack_public_path__ + "static/media/service_securing.ab4ae7bc3963420c09da1e227daaddd6.svg";
export { ForwardRef as ReactComponent };